import React, { useEffect } from "react";
import MainAppHeader from "./components/MainAppHeader";
import FileUpload from "./FileUpload";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { AppContainer } from "./MainStyles";
import { onSnapshot } from "firebase/firestore";
import chatImage from "../Assets/10.png";
import { useTheme, LinearProgress } from "@mui/material";
import { auth, firestore, doc } from "./firebase";

function MainApp() {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isActive, setIsActive] = React.useState(false);

  const muiTheme = useTheme();

  useEffect(() => {
    const authUnsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        const userDocRef = doc(firestore, "users", user.uid);

        const firestoreUnsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
          if (docSnapshot.exists()) {
            setIsActive(docSnapshot.data().isActive);
          }
        });

        // Cleanup Firestore listener when done
        return () => firestoreUnsubscribe();
      }
    });

    // Cleanup auth listener on unmount
    return () => authUnsubscribe();
  }, []);

  return (
    <StyledThemeProvider theme={muiTheme}>
      <AppContainer
        style={{ backgroundImage: `url(${chatImage})` }}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          height: "100vh",
          padding: "2vh 0",
        }}
      >
        <MainAppHeader />
        {isLoading && <LinearProgress />}
        <FileUpload setIsLoading={setIsLoading} />
      </AppContainer>
    </StyledThemeProvider>
  );
}

export default MainApp;
